var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F6F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 16.7501C13.25 16.405 13.5298 16.1251 13.875 16.1251H19C19.3452 16.1251 19.625 16.405 19.625 16.7501C19.625 17.0953 19.3452 17.3751 19 17.3751H13.875C13.5298 17.3751 13.25 17.0953 13.25 16.7501Z",
    fill: "#606DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 19.2501C13.25 18.905 13.5298 18.6251 13.875 18.6251H23C23.3452 18.6251 23.625 18.905 23.625 19.2501C23.625 19.5953 23.3452 19.8751 23 19.8751H13.875C13.5298 19.8751 13.25 19.5953 13.25 19.2501Z",
    fill: "#606DD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 12.3751C9.875 11.6848 10.4346 11.1251 11.125 11.1251H24.875C25.5654 11.1251 26.125 11.6848 26.125 12.3751V23.6251C26.125 24.3155 25.5654 24.8751 24.875 24.8751H11.125C10.4346 24.8751 9.875 24.3155 9.875 23.6251V12.3751ZM24.875 12.3751H11.125V23.6251H24.875V12.3751Z",
    fill: "#606DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPan);
export default __webpack_public_path__ + "static/media/pan.6d64a1008d4d0c0bcd4e7724533c63ec.svg";
export { ForwardRef as ReactComponent };